import styled, { css } from "styled-components";


export const Wrapper = styled.div(({ theme }) => css`
  .manage-repayments-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  .hide-mobile {
    display: none;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      display: block;
    }
  }

  .info-netbalance,
  .info-arrears,
  .info-repayments {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    padding: 10px 15px;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      padding: 0;
    }
  }

  .frown-icon {
    color: ${theme.palette.main.white};

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      color: ${theme.palette.status.bad};
    }
  }

  .line {
    flex: 1 0 4px;
    border-bottom: 2px solid #bebebe;
    margin: 10px 0 10px 0;
    max-width: 380px;
    display: none;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      display: block;
    }
  }

  .info-netbalance,
  .info-repayments {
    & > span {
      color: ${theme.palette.status.good};
      padding-left: 7px;

      @media only screen and (min-width: ${theme.breakpoints.M}) {
        color: ${theme.palette.status.goodAlt};
      }
    }
  }

  .info-arrears {
    color: ${theme.palette.main.white};
    background-color: #052d3b;

    & > span {
      color: ${theme.palette.status.bad};
      padding-left: 12px;
    }

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      color: black;
      background-color: ${theme.palette.main.white};
    }
  }

  .information-list {
    margin-bottom: 30px;
    padding-bottom: 15px;
    color: ${theme.palette.main.white};
    background-color: ${theme.palette.text.body};
    border-radius: 15px;
    width: 100%;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      margin-bottom: 54px;
      padding: 0 40px 0 0;
      background-color: ${theme.palette.main.white};
      border-radius: none;
      color: ${theme.palette.main.black};
      width: auto;
    }
  }

  .account-details {
    padding-bottom: 14px;
    margin-right: -24px;

    & > * {
      margin-right: 12px;
    }
  }

  .account-title {
    margin-top: 12px;
  }

  .red-text {
    color: ${theme.palette.main.white};

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      color: ${theme.palette.status.bad};
    }
  }

  .info-title-group, .info-title-group-arrears {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    background-color: #052d3b;
    border-radius: 15px 15px 0 0;
    padding: 15px 15px;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      margin-bottom: 20px;
      background-color: white;
      border-radius: 0;
      padding: 0;
    }
  }

  .info-title-group-arrears {
    background-color: ${theme.palette.status.bad};

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      background-color: white;
    }
  }

  .info-title {
    padding-left: 15px;
    font-size: 20px;
  }

  .manage-repayments-title {
    margin-top: 10px;
  }

  .manage-repayments-widget {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    width: 100%;

    h2 {
      text-align: left;
    }

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      flex-direction: row;
      align-items: flex-start;
      padding-top: 30px;
      width: auto;
    }
  }
`);
